import React from 'react';

const PageUp = (extraStyles?: React.CSSProperties) => {
    return (
        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" style={extraStyles}>
            <path d="M1.20069 17.9679H22.8007C23.0194 17.9672 23.2337 17.9069 23.4207 17.7934C23.6077 17.68 23.7601 17.5177 23.8617 17.324C23.9633 17.1304 24.0102 16.9127 23.9972 16.6944C23.9843 16.4761 23.912 16.2654 23.7883 16.0851L12.9883 0.4851C12.5407 -0.1617 11.4631 -0.1617 11.0143 0.4851L0.214288 16.0851C0.0892783 16.265 0.0159695 16.4758 0.00232671 16.6945C-0.011316 16.9131 0.0352291 17.1314 0.136905 17.3254C0.238581 17.5195 0.391499 17.682 0.579045 17.7953C0.766591 17.9085 0.981592 17.9682 1.20069 17.9679ZM12.0007 3.2763L20.5111 15.5679H3.49029L12.0007 3.2763Z" fill="currentColor" />
        </svg>

    );
};

export default PageUp;
